import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';

const useStyles = makeStyles<DefaultTheme>({
    view_horizon_waxiness: {
        width: '100%',
        marginBottom: '20px !important',
        backgroundColor: 'transparent',
    },
    view_horizon_waxiness_title: {
        backgroundColor: 'transparent',
        marginBottom: '10px !important',
    },
    text_horizon_waxiness: {
        fontFamily: 'serca-condensed-text',
        letterSpacing: 1,
        fontSize: 16,
        color: "#000000",
        fontWeight: "bold",
        textAlign: "center"
    },
    view_horizon_waxiness_subtitle: {
        flexDirection: 'column',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text_horizon_waxiness_subtitle: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
        alignItems: 'center',
    },
    view_horizon_waxiness_content: {
        width: '100%',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        marginBottom: '10px !important',
        justifyContent: 'space-around',
    },
    picker_select_type: {
        padding: '10px 20px !important',
        borderRadius: 15,
        width: '300px',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px !important',
        backgroundColor: 'transparent',
        '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#06617c !important',
        }
    },
    picker_select_item: {
        color: '#000',
        backgroundColor: 'transparent',
        width: '100%',
        alignItems: 'center',
        textAlign: 'center',
        fontFamily: 'serca-condensed-text',
        fontSize: 16,
    },
});

export default useStyles;